module.exports = __webpack_public_path__ + "static/2-min-eaeeb8d7df6f73cbf60085c956ab892b.jpg";